import React from 'react';
import UserMenu from './UserMenu';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="layout-container">
      <header className="layout-header">
        <div className="header-content">
          <div className="header-left">
            <h1 className="header-title">智能公文排版系统</h1>
            <nav className="header-nav">
              <Link 
                to="/" 
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              >
                📄 公文排版
              </Link>
              <Link 
                to="/schedule" 
                className={`nav-link ${location.pathname === '/schedule' ? 'active' : ''}`}
              >
                📅 行程排版
              </Link>
              <Link 
                to="/table-sign" 
                className={`nav-link ${location.pathname === '/table-sign' ? 'active' : ''}`}
              >
                🏷️ 台签排版
              </Link>
              <Link 
                to="/unit-sort" 
                className={`nav-link ${location.pathname === '/unit-sort' ? 'active' : ''}`}
              >
                📋 单位排版
              </Link>
              <Link 
                to="/messages" 
                className={`nav-link ${location.pathname === '/messages' ? 'active' : ''}`}
              >
                💬 留言板
              </Link>
            </nav>
          </div>
          <UserMenu />
        </div>
      </header>
      <div className="security-banner">
        <span className="security-icon">🔒</span>
        <span className="security-text">
          数据本地处理，如同上门维修，只修不带。我们承诺！全程处理都在您本地电脑的浏览器上！
        </span>
      </div>
      <main className="layout-main">
        {children}
      </main>
    </div>
  );
};

export default Layout;
